import {useLocation} from 'react-router'

import {useAppSelector} from 'app/store'
import classNames from 'classnames'
import {usePoliciesQuery} from 'features/Policies/usePolicyQuery'
import {useFeatureFlag, usePolicy} from 'hooks'
import {Policy, PolicyRoutesEnum} from 'interfaces'
import {NavLink} from '../LeftNavLink'
import {CanIAccess, PERMISSIONS} from 'rbac'
import {TooltipBody, TooltipWrapper} from 'components'

export function PoliciesLeftNavigation() {
  const {isSSLInspectionDisabled} = useFeatureFlag()
  const {selectedPolicyName} = useAppSelector(rdxSt => rdxSt.policies)
  const location = useLocation<{policyName: string}>()
  const {pathname} = location
  usePoliciesQuery()

  const {isBasePolicyToBeColored} = usePolicy()

  return (
    <div
      className={classNames('flex flex-col items-start pt-3 px-5 h-full', {
        'bg-dope-teal-100': isBasePolicyToBeColored,
      })}
    >
      <NavLink
        pathname={PolicyRoutesEnum.POLICIES_CONTENT}
        first
        current={pathname === PolicyRoutesEnum.POLICIES_CONTENT}
        linkName="Content"
        currentPolicyName={selectedPolicyName}
      />
      <CanIAccess reqPermissions={[PERMISSIONS.VIEW_POLICY_USERS.READ]}>
        <NavLink
          pathname={PolicyRoutesEnum.USERS}
          first
          current={pathname === PolicyRoutesEnum.USERS}
          linkName="Users"
          currentPolicyName={selectedPolicyName}
          classNames={`${
            selectedPolicyName === Policy.BasePolicy ? 'hidden' : 'block'
          }`}
        />
      </CanIAccess>

      <CanIAccess reqPermissions={[PERMISSIONS.VIEW_POLICY_CAC.READ]}>
        <div
          // Show tooltip only when SSL Inspection is disabled
          {...(isSSLInspectionDisabled && {
            'data-tooltip-id': 'policies-left-navigation-tooltip',
          })}
        >
          <NavLink
            pathname={PolicyRoutesEnum.CLOUD_APP}
            first
            current={pathname === PolicyRoutesEnum.CLOUD_APP}
            linkName="Cloud App"
            currentPolicyName={selectedPolicyName}
            disabled={isSSLInspectionDisabled}
          />
        </div>
      </CanIAccess>

      <CanIAccess reqPermissions={[PERMISSIONS.DLP_POLICY_CONFIGURATION.READ]}>
        <div
          // Show tooltip only when SSL Inspection is disabled
          {...(isSSLInspectionDisabled && {
            'data-tooltip-id': 'policies-left-navigation-tooltip',
          })}
        >
          <NavLink
            pathname={PolicyRoutesEnum.DLP}
            current={pathname === PolicyRoutesEnum.DLP}
            linkName="DLP"
            currentPolicyName={selectedPolicyName}
            disabled={isSSLInspectionDisabled}
          />
        </div>
      </CanIAccess>
      <CanIAccess reqPermissions={[PERMISSIONS.POLICY_BYPASS.READ]}>
        <NavLink
          pathname={PolicyRoutesEnum.BYPASS}
          first
          current={pathname === PolicyRoutesEnum.BYPASS}
          linkName="Bypass"
          currentPolicyName={selectedPolicyName}
        />
      </CanIAccess>

      <TooltipWrapper
        id="policies-left-navigation-tooltip"
        noArrow
        noPadding
        render={() => (
          <TooltipBody>
            {'This feature requires SSL Inspection to be turned ON.'}
          </TooltipBody>
        )}
        className="z-20"
      />
    </div>
  )
}
